module.exports = __webpack_public_path__ + "static/media/hostpinnacle-logo.8b63f578.png";